import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7aa59073"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "photography" }
const _hoisted_2 = {
  key: 0,
  class: "image-list"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { key: 1 }

import { ref, onMounted } from 'vue';
import axios from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhotographyView',
  setup(__props) {

const images = ref<string[]>([]);


const fetchImages = async (folderPath: string) => {
  try {
    const response = await axios.get('https://personal-website-yingchenarthurlius-projects.vercel.app/api/list-images', {
      params: { folder: folderPath }
    });
    images.value = response.data;
  } catch (error) {
    console.error('Error fetching images:', error);
  }
};

onMounted(() => {
  fetchImages('Banff');
});


return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { style: {"height":"100%"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_scrollbar, null, {
              default: _withCtx(() => [
                _createElementVNode("h1", null, _toDisplayString(_ctx.$t('PhotographyView.cityList')), 1),
                _createVNode(_component_el_menu, {
                  "default-active": "1",
                  class: "el-menu-vertical-demo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, {
                      index: "1",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (fetchImages('Banff')))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('PhotographyView.banff')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, {
                      index: "2",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (fetchImages('Boston')))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('PhotographyView.boston')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, {
                      index: "3",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (fetchImages('Cancun')))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('PhotographyView.cancun')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, {
                      index: "4",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (fetchImages('YunNan')))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('PhotographyView.yunnan')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_scrollbar, null, {
                  default: _withCtx(() => [
                    (images.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (image) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: image,
                              class: "image-item"
                            }, [
                              _createElementVNode("img", {
                                src: image,
                                alt: image
                              }, null, 8, _hoisted_3)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t('PhotographyView.loading')), 1)
                        ]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})